import { styled } from '@mui/material/styles';

const Image = styled('img')({});

export default Image;